import { Component, EventEmitter, Input, Output } from '@angular/core';

import { TipsVariantEnum } from '~/component/tips/enum/variant.enum';
import { VtmnPlayIconTypeEnum } from '../vtmn-play-icon/enums/vtmn-play-icon-type.enum';
import { VtmnPlayIconButtonVariantEnum } from '../buttons/vtmn-play-icon-button/enum/vtmn-play-icon-button-variant.enum';
import { CtaButtonTypeEnum } from '../call-to-action/enums/button-type.enum';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
})
export class ToastComponent {
  @Input() public description?: string;
  @Input() public header: string;
  @Input() public iconName = VtmnPlayIconTypeEnum.Information;
  @Input() public index: number;
  @Input() public variant = TipsVariantEnum.INFO;

  @Output() public readonly closeToast = new EventEmitter<number>();

  public readonly ctaButtonType = CtaButtonTypeEnum;
  public readonly ctaVariant = VtmnPlayIconButtonVariantEnum.TERTIARY;
  public readonly iconClose = VtmnPlayIconTypeEnum.CloseCircle;

  public clickClose(): void {
    this.closeToast.emit(this.index);
  }
}
